import searchForm from './search-form';
import accordion from './accordion';
import mobileMenu from './mobile-menu';
import loadMore from './content-load-more';
import modal from './modal';

searchForm();
accordion();
mobileMenu();
loadMore();
modal();
